export default __webpack_public_path__ + "static/media/placeholder-1.6590f3a3.png";